import { useDispatch } from "react-redux";
import { deleteAllImages } from "store/features/compress/actions";

export const useDelete = () => {
    const dispatch = useDispatch();

    const handleDelete = () => dispatch(deleteAllImages());

    return { handleDelete };
};
